<div class="header-left">
  <!-- Logo -->
  <a routerLink="/home" class="header-logo">
    <img src="img/greatday_logo.svg" alt="GreatDay" class="logo-svg">
  </a>
  
  <!-- Low minutes toast - mobile only, positioned over logo, only on home page -->
  @if (isHomePage()) {
    <div class="toast-container-mobile">
      <app-low-minutes-toast></app-low-minutes-toast>
    </div>
  }
</div>

<!-- Navigation - Desktop only -->
<div class="header-center desktop-only">
  <nav class="nav-links">
    <a routerLink="/home" routerLinkActive="active" class="nav-link">{{ 'sidenav.navigation.home' | translate }}</a>
    <a routerLink="/avatars" routerLinkActive="active" class="nav-link">{{ 'avatars.title' | translate }}</a>
    <a routerLink="/matches" routerLinkActive="active" class="nav-link nav-link-badge">
      {{ 'matches.title' | translate }}
      @if (matchActionableCount$ | async; as count) {
        @if (count > 0) {
          <span class="nav-badge">{{ count }}</span>
        }
      }
    </a>
    <a routerLink="/billing" routerLinkActive="active" class="nav-link">{{ 'sidenav.navigation.subscriptionPricing' | translate }}</a>
    <a routerLink="/settings" routerLinkActive="active" class="nav-link">{{ 'settings.title' | translate }}</a>
    @if (isManagerOrAdmin$ | async) {
      <a routerLink="/manager/feedback" routerLinkActive="active" class="nav-link">{{ 'managerDashboard.navLink' | translate }}</a>
    }
  </nav>
</div>

<div class="header-right">
  <!-- Language selector button - Desktop -->
  <div class="language-selector desktop-only" 
       [class.with-border]="(subscription$ | async) && shouldShowTimeTracker(subscription$ | async)">
    <button class="language-button" [matMenuTriggerFor]="languageMenu" #languageTrigger="matMenuTrigger" type="button">
      <span class="language-flag">{{ getCurrentLanguageOption().flag }}</span>
      <iconify-icon [icon]="languageTrigger.menuOpen ? 'mdi:chevron-up' : 'mdi:chevron-down'" class="chevron-icon"></iconify-icon>
    </button>
    <mat-menu #languageMenu="matMenu" class="language-menu">
      @for (option of languageOptions(); track option.value) {
        <button 
          mat-menu-item 
          class="language-menu-item"
          [class.selected]="currentLanguage() === option.value"
          (click)="onLanguageSelect(option.value)">
          <span class="language-flag">{{ option.flag }}</span>
          <span class="language-label">{{ option.label }}</span>
        </button>
      }
    </mat-menu>
  </div>

  <!-- Time tracker with get more button - Desktop only, visible when <= 5 min left -->
  @if (subscription$ | async; as subscription) {
    @if (shouldShowTimeTracker(subscription)) {
      <div class="time-tracker-wrapper time-tracker-desktop-only">
        <div class="time-tracker">
          <iconify-icon icon="mdi:clock-outline"></iconify-icon>
          <span>{{ getRemainingMinutesText(subscription) }}</span>
        </div>
        <button class="get-more-button" (click)="onGetMore()">
          <span>{{ 'common.buttons.getMore' | translate }}</span>
          <iconify-icon icon="heroicons-outline:arrow-right-circle"></iconify-icon>
        </button>
      </div>
    }
  }

  <!-- Language selector button - Mobile -->
  <div class="language-selector mobile-only">
    <button class="language-button" [matMenuTriggerFor]="languageMenuMobile" #languageTriggerMobile="matMenuTrigger" type="button">
      <span class="language-flag">{{ getCurrentLanguageOption().flag }}</span>
      <iconify-icon [icon]="languageTriggerMobile.menuOpen ? 'mdi:chevron-up' : 'mdi:chevron-down'" class="chevron-icon"></iconify-icon>
    </button>
    <mat-menu #languageMenuMobile="matMenu" class="language-menu">
      @for (option of languageOptions(); track option.value) {
        <button 
          mat-menu-item 
          class="language-menu-item"
          [class.selected]="currentLanguage === option.value"
          (click)="onLanguageSelect(option.value)">
          <span class="language-flag">{{ option.flag }}</span>
          <span class="language-label">{{ option.label }}</span>
        </button>
      }
    </mat-menu>
  </div>

  <!-- Mobile menu button -->
  <button class="menu-button mobile-only" type="button" (click)="onMenuClick()">
    <iconify-icon icon="mdi:menu"></iconify-icon>
  </button>
</div>